import { useState } from 'react'
import { POSITIONS_TABS } from '../../data/portfolio'
import ChartTabScroller from './ChartTabScroller'
import PillTab from './PillTab'
import PositionsEmpty from './PositionsEmpty'

export default function PositionsPanel({ connected }) {
  const [tab, setTab] = useState('Positions')

  return (
    <section className="mt-3" style={{ opacity: 1, transform: 'none' }}>
      <div
        data-trade-panel="positions"
        className="flex size-full flex-col overflow-hidden rounded-modal border-[0.5px] border-line bg-fill max-mobile:min-h-[300px] max-mobile:gap-2"
      >
        <div className="flex shrink-0 justify-between gap-2 border-b-[0.5px] border-line max-mobile:flex-col">
          <ChartTabScroller
            scrollerClassName="-my-0.5 no-scrollbar min-w-0 overflow-x-auto px-1 py-2"
            rightOffset="0px"
          >
            {POSITIONS_TABS.map((label) => (
              <PillTab
                key={label}
                label={label}
                pressed={tab === label}
                onClick={() => setTab(label)}
              />
            ))}
          </ChartTabScroller>
        </div>
        <div
          className="flex flex-col overflow-scroll max-mobile:h-[432px] h-[max(400px,calc(100vh-560px))]"
          data-testid="user-orders-table"
        >
          <PositionsEmpty connected={connected} tab={tab} />
        </div>
      </div>
    </section>
  )
}
